module.exports = __webpack_public_path__ + "static/media/icon-email-black.6648f216.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-email-black.svg
// module id = 1461
// module chunks = 0